import { createAction, props } from "@ngrx/store";
import { ErrorModel, LocationStatisticsResponse } from "../../../../core/cms-api/models";

export const loadLocationStatistics =
    createAction('[Locations] Load location statistics', props<{ locationId: string, dateFrom?: string | null, dateTo?: string | null }>());

export const loadLocationStatisticsSuccess =
    createAction('[Locations] Load location statistics success',
        props<{ locationStatistics: LocationStatisticsResponse }>());

export const loadLocationStatisticsFailure =
    createAction('[Locations] Load location statistics failure',
        props<{ error: ErrorModel }>());